export default __webpack_public_path__ + "static/spacebudz-2e6e9d069bb1c87ea4c3f2d013966fa6.svg";